import { consumptionMetricIds } from '@/components/Workflow/Show/Views/Consumption/Consumption.utils';
import { type PresetCalculation } from '@/model/PresetCalculation.model';

export const getColumnContextMetrics = (calculations: Array<PresetCalculation> = []): Array<PresetCalculation> => {
  return calculations.filter((calc) => !consumptionMetricIds.has(calc.id));
};
